import { apiURL, responseFormat } from '@/service/base'
import { MembersClient } from '@circusmonkey/spock-protobuf/ts/frontend/member_grpc_web_pb.js'

const client = new MembersClient(apiURL, null, null)

/**
 * 取餘額
 * @param func
 * @returns {Promise<unknown>}
 */
async function getBalance(params = {}, func = null) {
	const req = new proto.base.Empty()

	const option = { 'grpc-session': localStorage.getItem('grpc-session') }
	const url = String(client.balance.toString().split('\n')[2]).replace(/\s+/g, '')
	const track = { req: req.toObject(), url }
	// console.log('getBalance grpc-session', option)
	return new Promise((resolve, reject) => {
		client.balance(req, option, (err, response) => {
			if (typeof func === 'function') resolve(func(err, response, track))
			else resolve(responseFormat(err, response, track, true, 'balance'))
		})
	}).then(resp => resp)
}

export {
	getBalance
}
